import React from "react";
import "../homepage/homepage.css";
import Intropart from "./sections/intropart/intropart";
import About from "./sections/about/about";
import Services from "./sections/services/services";
import SectionBlog from "./sections/blog/blog";
import Contactus from "./sections/contactus/contactus";
import Contact from "../../components/contact/contact";
import Portfolio from "./sections/portfolio/portfolio";
import Lottie from "lottie-react-web";
import animationData from "../../../assets/loading.json";

export default class Homepage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contact: false,
    };
    this.windowOffSet = 0;
  }

  render() {
    return (
      <div className="homepagecontainer">
        <Intropart />
        <About />
        <Services />
        <SectionBlog />
        <Contactus handleContact={this.props.handleContact} />
        <Portfolio />
      </div>
    );
  }
}
